import React, { Component } from 'react';
import { connect } from 'dva';
// eslint-disable-next-line import/no-extraneous-dependencies
import router from 'umi/router';
import { Button, Form, Tabs, Spin, Icon, Upload, message, Modal, Tooltip, Popconfirm } from 'antd';
import WxEditor from '@/components/WxEditor';
import moment from 'moment';
import FormCreate from '../../../../../components/FormCreate/index';
import Container from '../../../../../components/Container';
import PublishModal from '../components/PublishModal';
import { url as api } from '../../services/service-utils';
import { GetQueryString, getAppCode, eduAppCode } from '../../utils/utils';
import { convertData, getDefaultData } from '../../utils/convertData';
import SelectTagModal from '../CreateVideo/SelectTag/index';
import styles from './index.less';

const deleteIcon = 'https://s.xiaoyuanhao.com/file/2f3fd4fd-c88c-440e-b6ed-0cf9b5952909.svg';
const downIcon = 'https://s.xiaoyuanhao.com/file/ad123855-7990-4d44-92b7-75a634544a1a.svg';
const upIcon = 'https://s.xiaoyuanhao.com/file/5b8639da-c41a-448b-aa11-8f15c9d19707.svg';

const defaultImageUrl = 'https://s.xiaoyuanhao.com/file/d7370415-e33f-4b94-ace6-9b8407ae6330.png';

const { TabPane } = Tabs;

const { Item } = Form;
const {
  FormTitle,
  FormCascader,
  FormTextArea,
  FileUpload,
  SenderUser,
  FormRadioGroup,
  Publisher,
  SelectUserVersion4,
  FormCheckbox,
  RangeSelectUser,
  FormSelect,
  SendTime,
} = FormCreate;

const customerFormItemLayout = {
  labelCol: { span: 3 },
  wrapperCol: { span: 20 },
};

// eslint-disable-next-line camelcase
let wweiEditor = null;
@Form.create()
@connect(({ edit, articleSubmissions, user }) => ({
  ...edit,
  ...articleSubmissions,
  currentUser: user.currentUser,
}))
class Edit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      previewImage: '',
      previewVisible: false,
      spinning: false,
      channelList: [],
      activeKey: '1',
      checkedValue: [],
      groupData: [],
    };
    this.id = GetQueryString('id');
    this.from = GetQueryString('from');
    this.newstype = GetQueryString('newstype');
    this.moduleId = GetQueryString('moduleId');
    this.activeKey_key = GetQueryString('activeKey_key');
    this.appCode = getAppCode();
  }

  componentDidMount() {
    const { dispatch, formData } = this.props;
    const { newstype } = formData;
    const newsType = this.newstype || newstype;
    if (newsType === '0') {
      wweiEditor = window.UE.getEditor('wwei_editor');
    }
    this.fetchChannelList();
    this.getAuditConfig()
    if (!this.id) {
      dispatch({
        type: 'edit/saveState',
        payload: {
          formData: {
            ...formData,
            appCode: getAppCode(),
            selectIdType: 5,
          },
          articleList: [
            {
              newstype: this.newstype,
              title: '',
              summary: '',
              url: '',
              coverPicFileId: '',
              content: '',
              fileId: '',
              labelList: [],
              status: '',
              statusDesc: '',
              channelId: undefined, // 栏目id
              fileList: [],
              filesLength: 0,
            }
          ],
        },
      });
      dispatch({
        type: 'edit/fetchLabelWithGroup',
        params: { appCode: getAppCode() },
      }).then(res => {
        this.setState({
          checkedValue: [],
          groupData: res,
        });
      });
    }
    if (this.activeKey_key === '2') {
      this.setState({
        activeKey: '2',
      });
    }
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch({
      type: 'edit/reset',
    });
  }

  getAuditConfig = () => {
    const { dispatch } = this.props;
    dispatch({
      type: 'edit/fetchLeaveWordConf',
      params: {
        appCode: getAppCode(),
      },
    })
  };

  setWweiEditorContent = content => {
    wweiEditor = window.UE.getEditor('wwei_editor');
    wweiEditor.ready(() => {
      wweiEditor.setContent(content);
    });
  }

  fetchNewsById = channelList => {
    const { dispatch, formData } = this.props;
    this.setState({ spinning: true });
    dispatch({
      type: 'edit/fetchNewsById',
      params: { id: this.id },
    })
      .then(res => {
        const arr = [];
        res.labelList.map(item => {
          arr.push({
            labelName: item.label,
            labelId: item.id,
          });
        });
        dispatch({
          type: 'edit/fetchLabelWithGroup',
          params: { appCode: getAppCode() },
        }).then(labelData => {
          labelData.forEach(item => {
            item.list.forEach(tag => {
              res.labelList.forEach(checkedValue => {
                if (checkedValue.id === tag.labelId) {
                  tag.checked = true;
                }
              });
            });
          });
          this.setState({
            spinning: false,
            checkedValue: arr,
            groupData: labelData,
          });
        });
        const { newstype, title, summary, url, coverPicFileId, content, fileId, status, statusDesc, channelId, publishUserName, newsInfoExtend } = res;
        const { isTiming, timingPushTime } = newsInfoExtend || {}
        dispatch({
          type: 'edit/saveState',
          payload: {
            formData: {
              ...formData,
              ...res,
              publishUserName,
              isTiming,
              timingPushTime: isTiming === 1 ? moment(timingPushTime).format('YYYY-MM-DD HH:mm:ss') : '',
            },
            articleList: [{
              newstype,
              title,
              summary,
              url,
              coverPicFileId,
              content,
              fileId,
              labelList: arr,
              status,
              statusDesc,
              channelId: getDefaultData(channelList, channelId),
              fileList: [
                {
                  uid: '-1',
                  name: 'image.png',
                  status: 'done',
                  url: res.coverPicFileUrl,
                },
              ],
            }]
          },
        });

        if (res.newstype === '0') {
          this.setWweiEditorContent(content)
        }
      })
      .catch(() => {
        this.setState({ spinning: false });
      });
  };

  fetchTemplateById = () => {
    const { dispatch, articleList } = this.props;
    this.setState({ spinning: true });
    dispatch({
      type: 'edit/fetchTemplateById',
      params: { templateId: this.moduleId },
    })
      .then(res => {
        this.setState({ spinning: false });
        const { templateTitle, templateSummary, templateCoverPicFileId, templateCoverPicFileIdUrl, templateContent } = res;
        articleList[0].title = templateTitle;
        articleList[0].summary = templateSummary;
        articleList[0].coverPicFileId = templateCoverPicFileId;
        articleList[0].fileList = [
          {
            uid: '-1',
            name: 'image.png',
            status: 'done',
            url: templateCoverPicFileIdUrl,
            thumbUrl: templateCoverPicFileIdUrl,
          },
        ];
        dispatch({
          type: 'edit/saveState',
          payload: {
            articleList
          },
        });
        if (res.newstype === '0' || this.newstype === '0') {
          this.setWweiEditorContent(templateContent)
        }
      })
      .catch(() => {
        this.setState({ spinning: false });
      });
  };

  fetchChannelList = () => {
    const { dispatch } = this.props;
    this.setState({ spinning: true });
    dispatch({
      type: 'edit/fetchChannelList',
      params: { appCode: getAppCode(), iseditnews: 1 },
    })
      .then(res => {
        this.setState({ channelList: convertData(res || []), spinning: false });

        this.fetchInitiatorName(res);
      })
      .catch(() => {
        this.setState({ spinning: false });
      });
  };

  fetchInitiatorName = res => {
    const { dispatch } = this.props;
    this.setState({ spinning: true });
    dispatch({
      type: 'edit/fetchInitiatorName',
      params: { appCode: getAppCode() },
    })
      .then(() => {
        this.setState({ spinning: false });
        if (this.id) {
          this.fetchNewsById(res || []);
        } else if (this.moduleId) {
          this.fetchTemplateById(res || []);
        }
      })
      .catch(() => {
        this.setState({ spinning: false });
      });
  };

  handleCancel = () => {
    this.setState({
      previewImage: '',
      previewVisible: false,
    });
  };

  changeTab = activeKey => {
    this.setState({ activeKey });
  };

  saveData = (value, type) => {
    const { dispatch, formData, defaultDataChannelId } = this.props;
    const obj = {};
    obj[type] = type === 'channelId' ? value[value.length - 1] : value;
    dispatch({
      type: 'edit/saveState',
      payload: {
        formData: {
          ...formData,
          ...obj,
        },
        defaultDataChannelId: type === 'channelId' ? value : defaultDataChannelId,
      },
    });
  };

  handleChange = info => {
    let { fileList } = info;
    fileList = fileList.slice(-1);
    fileList = fileList.map(file => {
      if (file.response) {
        if (file.response.code !== 0) {
          message.info(file.response.msg);
        }
      }
      return file;
    });
    fileList = fileList.filter(file => {
      if (file.response) {
        if (file.response.code !== 0) {
          message.info(file.response.msg);
        }
        return file.response.code === 0;
      }
      return true;
    });

    this.handleFormChange('coverPicFileId', fileList[0] && fileList[0].response && fileList[0].response.data && fileList[0].response.data.fileId)
    this.handleFormChange('fileList', fileList)

  };

  handleFileGroupId = (fileId, length) => {
    this.handleFormChange('fileId', fileId)
    this.handleFormChange('filesLength', length)
  };

  resetInitiatorName = value => {
    const { initiatorNameData, form, formData, dispatch } = this.props;
    const { userName, orgName } = initiatorNameData;
    dispatch({
      type: 'edit/saveState',
      payload: {
        formData: {
          ...formData,
          publishUserName: value === 1 ? orgName : userName,
        },
      },
    });
    const { setFieldsValue } = form;
    setFieldsValue({ publishUserName: value === 1 ? orgName : userName });
  };

  nextStep = () => {
    const { activeKey } = this.state;
    this.setState({ activeKey: `${Number(activeKey) + 1}` });
  };

  preStep = () => {
    const { activeKey } = this.state;
    this.setState({ activeKey: `${Number(activeKey) - 1}` });
  };

  validateRequiredFun = data => {
    const { title, content, coverPicFileId, channelId, url } = data;

    if (Number(this.newstype) === 0) {
      if (title?.length && content?.length && coverPicFileId?.length && channelId?.length) {
        return true
      }
    } else if (title?.length && url?.length && coverPicFileId?.length && channelId?.length) {
      return true
    }
  }

  handleOk = status => {
    const { form, dispatch, formData, articleList } = this.props;
    const { validateFields, getFieldsValue } = form;
    const { selectId } = formData;
    const keys = []
    const values = getFieldsValue();
    const { selectIdType, isTiming, publishTimeString } = values;
    articleList.forEach((item, index) => {
      if (!this.validateRequiredFun(item)) {
        keys.push(index)
      }
    })
    if (keys.length > 0) {
      dispatch({
        type: 'edit/saveState',
        payload: {
          currentIndex: keys[0],
        },
      });
      message.error('信息填写页必填项未填写完整');
      return;
    };

    if (Number(isTiming) === 1) {
      if (new Date() > new Date(publishTimeString)) {
        message.error('定时发送选择时间小于现在时间');
        return;
      }
    }

    validateFields(['selectId', 'selectIdType'], (errors) => {
      if (!errors) {
        if (!selectId && !eduAppCode[this.appCode] && selectIdType !== 5) {
          message.error('推送范围的标签和组织均需必填');
          return;
        }
        if (status === 'preview') {
          this.saveArticle(status);
        } else if (status === 'submit') {
          dispatch({
            type: 'edit/saveState',
            payload: { publishModalVisible: true },
          });
        } else {
          this.saveArticle(status);
        }
      } else {
        message.error('对象选择页面必填项未填写完整');
      }
    });
  };

  saveArticle = status => {
    const { form, formData, articleList } = this.props;
    const { getFieldsValue } = form;
    const values = getFieldsValue();
    const { newstype } = formData;
    const newsType = this.newstype || newstype;
    const arr = [];
    articleList.forEach(item => {
      const { channelId } = item;
      arr.push({
        ...item,
        channelId: channelId[channelId.length - 1],
      })
    });
    const params = {
      ...formData,
      ...values,
      newstype: newsType,
      saveType: status || '',
      publishUserName: newsType === '1' ? '' : values.publishUserName,
      visualRange: eduAppCode[this.appCode] ? '1' : '0',
      newsBaseInfoList: arr,
      timingPushTime: new Date(values.publishTimeString || formData.timingPushTime)
    };

    this.publishConfirm(params, status);
  };

  publishConfirm = (params, type) => {
    const { dispatch } = this.props;
    this.setState({ spinning: true });
    dispatch({
      type: 'edit/fetchBatchSave',
      params,
    })
      .then(res => {
        this.setState({ spinning: false });
        if (type === 'preview') {
          this.fetchNewsPreview(res);
          // this.setState({ previewId: res });
        } else if (type === 'submit') {
          // this.setState({ previewId: res });
          this.fetchSubmit(res);
        } else {
          message.success('保存成功');
          router.goBack();
        }
      })
      .catch(() => {
        this.setState({ spinning: false });
      });
  };

  fetchSubmit = ids => {
    const { dispatch } = this.props;
    this.setState({ spinning: true });
    dispatch({
      type: 'articleSubmissions/fetchSubmit',
      params: {
        ids: ids.toString(),
        appCode: getAppCode()
      },
    })
      .then(() => {
        this.setState({ spinning: false });
        message.success('提交成功');
        router.goBack();
      })
      .catch(() => {
        this.setState({ spinning: false });
      });
  };

  fetchNewsPreview = id => {
    const { dispatch } = this.props;
    this.setState({ spinning: true });
    dispatch({
      type: 'edit/fetchNewsPreview',
      params: { id: id.toString(), appCode: getAppCode() },
    })
      .then(() => {
        this.setState({ spinning: false });
        message.success('文章预览已发送至您的手机，请打开微信查看');
      })
      .catch(() => {
        this.setState({ spinning: false });
      });
  };

  renderTabTitle = (activeKey, title, index) => {
    return (
      <span>
        <i
          className={
            activeKey === index ? 'common-icon-style active-style' : 'common-icon-style icon-style'
          }
        >
          {index}
        </i>
        {title}
      </span>
    );
  };

  renderDraftButton = type => {
    return (
      <Button type={type && this.from ? 'primary' : 'default'} onClick={() => this.handleOk()}>
        保存
      </Button>
    );
  };

  renderFooter = () => {
    const { activeKey } = this.state;
    let footerParams = {};
    if (Number(getAppCode()) === 1) {
      if (activeKey !== '3') {
        footerParams = {
          states: !0,
          demFooter: (
            <>
              {activeKey !== '1' && (
                <Button type="default" onClick={this.preStep}>
                  上一步
                </Button>
              )}
              {this.renderDraftButton()}
              <Button type="primary" onClick={this.nextStep}>
                下一步
              </Button>
            </>
          ),
        };
      } else {
        footerParams = {
          states: !0,
          demFooter: (
            <>
              <Button type="default" onClick={this.preStep}>
                上一步
              </Button>
              <Button onClick={() => this.handleOk('preview')}>预览</Button>
              {this.renderDraftButton('save')}
              {!this.from && (
                <Button type="primary" onClick={() => this.handleOk('submit')}>
                  提交
                </Button>
              )}
            </>
          ),
        };
      }
    } else if (activeKey === '1') {
      footerParams = {
        states: !0,
        demFooter: (
          <>
            {this.renderDraftButton()}
            <Button type="primary" onClick={this.nextStep}>
              下一步
            </Button>
          </>
        ),
      };
    } else {
      footerParams = {
        states: !0,
        demFooter: (
          <>
            <Button type="default" onClick={this.preStep}>
              上一步
            </Button>
            <Button onClick={() => this.handleOk('preview')}>预览</Button>
            {this.renderDraftButton('save')}
            {!this.from && (
              <Button type="primary" onClick={() => this.handleOk('submit')}>
                提交
              </Button>
            )}
          </>
        ),
      };
    }
    return footerParams;
  };

  handleSaveLabelOk = data => {
    const { checkedValue, groupData } = data;
    this.setState({
      checkedValue,
      groupData,
    });

    this.handleFormChange('labelList', checkedValue)
  };

  handleFormChange = (type, data) => {
    const { dispatch, currentIndex, articleList } = this.props;
    const arr = JSON.parse(JSON.stringify(articleList))
    arr[currentIndex][type] = data;
    dispatch({
      type: 'edit/saveState',
      payload: {
        articleList: arr
      },
    });
  }

  renderInformation = () => {
    const that = this;
    const {
      previewImage,
      previewVisible,
      channelList = [],
      checkedValue = [],
      groupData = [],
    } = this.state;
    const { form, dispatch, articleList, currentIndex } = this.props;
    const { title, url, newstype, summary, fileId, content, fileList, channelId, filesLength } = articleList[currentIndex] || {}
    const { getFieldDecorator } = form;
    const newsType = this.newstype || newstype;
    const formItemLayout = {
      labelCol: { span: 3 },
      wrapperCol: { span: 20 },
    };

    const uploadButton = (
      <div>
        <Icon type="plus" />
        <div className="ant-upload-text">上传封面</div>
      </div>
    );
    const props = {
      action: `${api.url}/web/v3/news/file/upload`,
      data: { newsType },
      withCredentials: true,
      name: 'file',
      listType: 'picture-card',
      fileList,
      beforeUpload(file) {
        return new Promise((resolve, reject) => {
          const type = ['image/jpeg', 'image/png', 'image/jpg'];
          const isJPG = type.indexOf(file.type) !== -1;
          if (!isJPG) {
            message.error('只能上传jpg/png/jpeg格式图片!');
          }
          const isLt4M = file.size / 1024 / 1024 < 5;
          if (!isLt4M) {
            message.error('图片不能大小超过5MB!');
          }
          if (!isJPG || !isLt4M) {
            // eslint-disable-next-line prefer-promise-reject-errors
            return reject(false);
          }
          return resolve(true);
        });
      },
      onPreview(file) {
        that.setState({
          previewImage: file.url || file.thumbUrl,
          previewVisible: true,
        });
      },
      onRemove() {
        dispatch({
          type: 'edit/saveState',
          payload: { fileList: [] },
        });
        that.handleFormChange('fileList', [])
        that.handleFormChange('coverPicFileId', '')
      },
    };

    const titleProps = {
      form,
      value: title,
      label: newsType === '0' ? '文章标题' : '外部文章标题',
      keyName: `title-${currentIndex}`,
      maxLength: 100,
      isRequired: true,
      suffix: `${title?.length || 0}/100`,
      onChange: e => this.handleFormChange('title', e.target.value),
    };

    const summaryProps = {
      form,
      value: summary,
      label: '文章摘要',
      keyName: `summary-${currentIndex}`,
      isRequired: false,
      maxLength: 200,
      rows: 4,
      onChange: e => this.handleFormChange('summary', e.target.value),
    };

    const channelIdProps = {
      form,
      value: channelId,
      label: '发布栏目',
      keyName: `channelId-${currentIndex}`,
      isRequired: true,
      optionsData: channelList,
      onChange: e => this.handleFormChange('channelId', e),
    };

    const urlProps = {
      form,
      value: url,
      label: '外部文章链接',
      keyName: `url-${currentIndex}`,
      onChange: e => this.handleFormChange('url', e.target.value),
    };

    const fileUploadProps = {
      className: 'file-upload',
      form,
      groupId: fileId,
      fileCount: filesLength,
      keyName: 'fileId',
      handleFileGroupId: this.handleFileGroupId,
    };

    return (
      <>
        <FormTitle {...titleProps} />
        {newsType === '0' && (
          <Item
            label={
              <span>
                文章内容
                {eduAppCode[this.appCode] && (
                  <Tooltip
                    placement="top"
                    title={
                      <span>
                        1.可支持秀米、135编辑器等图文编辑器编辑完成后复制使用。
                        <br />
                        2.可点击放大
                        <img
                          src="https://s.xiaoyuanhao.com/file/a44f53bb-40ce-454e-9bd3-d4243688b89d.png"
                          alt=""
                        />
                        编辑区域范围，编辑完成后缩小。
                      </span>
                    }
                    autoAdjustOverflow
                  >
                    <Icon type="question-circle" />
                  </Tooltip>
                )}
              </span>
            }
            className="content microsite-editor-content"
          >
            {getFieldDecorator(`content`, {
              initialValue: content,
              rules: [{ required: true, message: '请填写文章内容' }],
            })(<WxEditor showTemplate onChange={data => this.handleFormChange('content', data)} />)}
          </Item>
        )}
        {newsType === '1' && <FormTitle {...urlProps} />}
        <Form.Item label="封面" {...formItemLayout} className="necessary imgBox">
          {getFieldDecorator(`coverPicFileId`)(
            <>
              <Upload {...props} onChange={this.handleChange}>
                {fileList.length >= 1 ? null : uploadButton}
              </Upload>
              <Modal
                centered
                width={950}
                visible={previewVisible}
                footer={null}
                onCancel={this.handleCancel}
              >
                <div
                  style={{
                    backgroundImage: `url(${previewImage})`,
                    width: 900,
                    height: 383,
                    backgroundPosition: '50% 50%',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                  }}
                />
              </Modal>
            </>
          )}
          <div className="upload-img-tips">说明：建议尺寸900*383，封面图最大可上传5M</div>
        </Form.Item>
        <FormTextArea {...summaryProps} />
        <FormCascader {...channelIdProps} />
        <Form.Item label="关联标签" {...formItemLayout}>
          {getFieldDecorator(`labelList`, {
            initialValue: checkedValue,
            valuePropName: 'checkedValue',
            trigger: 'handleOk',
            // eslint-disable-next-line no-shadow
            getValueFromEvent: ({ checkedValue = [] } = {}) => {
              return checkedValue;
            },
            rules: [
              {
                required: false,
                message: '请选择标签',
              },
            ],
          })(
            <SelectTagModal
              checkedValue={checkedValue}
              groupData={groupData}
              handleOk={this.handleSaveLabelOk}
            />
          )}
          <div className="select-label-tips">说明: 最多可关联10个标签</div>
        </Form.Item>

        {newsType === '0' && <FileUpload key={fileId} {...fileUploadProps} />}
      </>
    );
  };

  changeLabelType = e => {
    const { dispatch, formData, form } = this.props;
    form.setFieldsValue({
      selectId: '',
    });
    dispatch({
      type: 'edit/saveState',
      payload: {
        formData: {
          ...formData,
          selectIdType: e.target.value,
          selectId: '',
        },
      },
    });
  };

  renderRangeSelectUserLabel = () => {
    return (
      <Tooltip placement="top" title="从已有系统标签规则选择组织精准推送" autoAdjustOverflow>
        系统标签内组织精准推送
        <Icon type="question-circle" style={{ marginLeft: 4 }} />
      </Tooltip>
    );
  };

  callbackSignature = data => {
    const { groupInfoList, orgRelInfoList, tagInfoList, selectSignature } = data;
    const { dispatch, formData } = this.props;

    const tempList = [...orgRelInfoList, ...groupInfoList];
    if (tempList.length > 0 && tagInfoList.length > 0) {
      dispatch({
        type: 'edit/saveState',
        payload: {
          selectId: selectSignature,
          formData: {
            ...formData,
            selectId: selectSignature,
          },
        },
      });
    } else {
      dispatch({
        type: 'edit/saveState',
        payload: {
          selectId: '',
          formData: {
            ...formData,
            selectId: '',
          },
        },
      });
    }
  };

  renderSelectUser = () => {
    const { form, formData, currentUser, dispatch } = this.props;
    const { selectId = '', selectIdType } = formData;
    const { orgType } = currentUser || {};

    const selectUserProps = {
      form,
      value: selectId,
      appName: '宣传管理',
      appId: 1,
      orgType,
      label: '对象选择',
      message: '选择需要发送的组织',
      keyName: 'selectId',
      isRequired: true,
      selectProps: {
        multiple: true,
        selectIdType: orgType === 'county' ? 'dept' : 'user',
        strictOrgRel: false,
        showTabList:
          orgType === 'school' ? ['dept', 'innerContacts', 'schoolContacts', 'tags'] : ['orgRel'],
        dialogProps: {
          title: '选择对象',
        },
        searchPlaceholder: '搜索名称',
        selectSignature: selectId,
        isSaveSelectSignature: true,
        requestParams: {
          strictUser: true,
          tagTypeList: orgType === 'school' ? ['0', '1'] : ['0', '1', '3'],
          selectTypeList:
            orgType === 'county' ? ['org_rel'] : ['user', 'dept', 'org', 'group', 'tags'],
        },
      },
      callback: data => {
        const { selectSignature = '' } = data;

        dispatch({
          type: 'edit/saveState',
          payload: {
            selectId: selectSignature,
            formData: {
              ...formData,
              selectId: selectSignature,
            },
          },
        });
      },
      itemFormProps:
        orgType === 'county'
          ? {
            labelCol: {
              span: 5,
            },
            wrapperCol: {
              span: 18,
            },
          }
          : {},
    };

    const rangeSelectUserProps = {
      form,
      value: selectId,
      appName: '活动打卡',
      appId: 40,
      orgType,
      label: this.renderRangeSelectUserLabel(),
      message: '系统标签内组织精准推送',
      keyName: 'selectId',
      isRequired: true,
      funCallbackSignature: data => this.callbackSignature(data),
      tagProps: {
        subtitle: '已选对象',
        btnText: '选择',
        btnDetele: true,
      },
      orgRelProps: {
        subtitle: '已选对象',
        btnText: '选择',
        btnDetele: true,
        showTabList: ['orgRel'],
        requestParams: {
          selectTypeList: ['org_rel'],
        },
      },
      itemFormProps: {
        labelCol: {
          span: 5,
        },
        wrapperCol: {
          span: 18,
        },
      },
    };

    const labelTypeProps = {
      form,
      value: selectIdType,
      label: '选择方式',
      keyName: 'selectIdType',
      isRequired: true,
      RadioGroupOptions:
        orgType === 'county'
          ? [
            { label: '本组织', value: 5 },
            { label: '按组织', value: 1 },
            { label: '按标签', value: 2 },
          ]
          : [
            { label: '本组织', value: 5 },
            { label: '指定人员范围', value: 4 },
          ],
      onChange: this.changeLabelType,
      itemFormProps:
        orgType === 'county'
          ? {
            labelCol: {
              span: 5,
            },
            wrapperCol: {
              span: 18,
            },
            style: { marginBottom: 16 },
          }
          : {
            style: { marginBottom: 16 },
          },
    };

    if (orgType === 'county') {
      return (
        <>
          <FormRadioGroup {...labelTypeProps} />
          {Number(selectIdType) === 1 && <SelectUserVersion4 {...selectUserProps} />}
          {Number(selectIdType) === 2 && <RangeSelectUser {...rangeSelectUserProps} />}
        </>
      );
    }
    return (
      <>
        <FormRadioGroup {...labelTypeProps} />
        {Number(selectIdType) === 4 && <SelectUserVersion4 {...selectUserProps} />}
      </>
    );
  };

  renderAttribute = () => {
    const { form, formData, currentUser, pushIsAudit } = this.props;

    const {
      newstype,
      needPush = '0',
      samePermissionsModuleId,
      publishUserNameType,
      publishUserName,
      qrCode,
      canLeaveWords,
      needUp = '0',
      needDown = '0',
      fromApp = 17,
      isTiming = 0,
      timingPushTime,

    } = formData;

    const { orgType } = currentUser || {};
    const newsType = this.newstype || newstype;

    const samePowerProps = {
      form,
      value: samePermissionsModuleId,
      appName: '会议管理',
      appId: 45,
      orgType,
      label: '相同权限人',
      message: '请选择相同权限人',
      keyName: 'samePermissionsModuleId',
      isRequired: false,
      tips: '说明: 选择的人员与创建人拥有相同权限',
    };

    const publisherProps = {
      form,
      nameKeyName: 'publishUserName',
      typeKeyName: 'publishUserNameType',
      initiatorNameType: publishUserNameType,
      initiatorName: publishUserName,
      resetInitiatorName: this.resetInitiatorName,
    };

    const code = {
      form,
      value: qrCode,
      label: '文末增加二维码',
      keyName: 'qrCode',
      isRequired: false,
      RadioGroupOptions: [
        { label: '是', value: '1' },
        { label: '否', value: '0' },
      ],
      tips: '说明：在文章末尾自动增加基本设置菜单栏中设置的二维码',
    };

    const leaveWordProps = {
      form,
      value: canLeaveWords,
      label: '允许留言',
      keyName: 'canLeaveWords',
      isRequired: false,
      RadioGroupOptions: [
        { label: '是', value: 1 },
        { label: '否', value: 0 },
      ],
      tips: '说明: 内容发布后是否允许用户在文章末留言',
    };

    const needPushProps = {
      form,
      value: needPush,
      label: '消息提醒',
      keyName: 'needPush',
      isRequired: false,
      RadioGroupOptions: [
        { label: '是', value: '1' },
        { label: '否', value: '0' },
      ],
      tips: '说明：对本次发布的对象推送消息提醒',
    };

    const reportProps = {
      form,
      value: needUp,
      label: '上报教育局',
      keyName: 'needUp',
      isRequired: false,
      RadioGroupOptions: [
        { label: '是', value: '1' },
        { label: '否', value: '0' },
      ],
      tips:
        '说明: 文章发布成功后将文章上报至已关联的上级教育部门，若当前组织不存在已关联的上级教育部门，则上报不生效',
    };

    const synchronousProps = {
      form,
      value: needDown,
      label: '文章同步',
      keyName: 'needDown',
      isRequired: false,
      RadioGroupOptions: [
        { label: '是', value: '1' },
        { label: '否', value: '0' },
      ],
      tips:
        '说明: 同步为将当前的文章内容增加至已选择的组织资讯管理列表，若当前组织不存在已关联的下属学校，则同步不生效',
    };

    const visibleRangeProps = {
      form,
      value: true,
      label: '内容可见范围',
      keyName: 'visualRange',
      content: '系统外游客人员不可见',
      isRequired: true,
      disabled: true,
      otherProps: {
        disabled: true,
        defaultChecked: true,
      },
    };

    const fromAppProps = {
      form,
      value: fromApp,
      label: '推送应用',
      keyName: 'fromApp',
      isRequired: false,
      optionData: [
        { value: 17, label: '微官网' },
        { value: 18, label: '活动打卡' },
      ],
    };

    const sendTimeProps = {
      form,
      isTiming,
      publishTimeString: timingPushTime,
    };

    return (
      <>
        {Number(getAppCode()) === 1 ? (
          <>
            {/* 发布者 */}
            {newsType === '0' && <Publisher {...publisherProps} />}
            {/* 相同权限人 */}
            <SenderUser {...samePowerProps} />
            {/* 消息提醒 */}
            <FormRadioGroup {...needPushProps} />
            {/* 推送应用 */}
            {orgType !== 'school' && pushIsAudit === 0 && Number(form.getFieldValue('needPush')) === 1 && <FormSelect {...fromAppProps} />}
            {/* 文章同步 */}
            {orgType !== 'school' && <FormRadioGroup {...synchronousProps} />}
            {/* 文末增加二维码 */}
            <FormRadioGroup {...code} />
            {/* 允许留言 */}
            {newsType === '0' && <FormRadioGroup {...leaveWordProps} />}
            {/* 上报教育局 */}
            <FormRadioGroup {...reportProps} />
            {
              pushIsAudit === 0 && <SendTime {...sendTimeProps} />
            }

          </>
        ) : (
            // eslint-disable-next-line react/jsx-indent
            <>
              {/* 发布者 */}
              {newsType === '0' && <Publisher {...publisherProps} />}
              {/* 相同权限人 */}
              <SenderUser {...samePowerProps} />
              {/* 允许留言 */}
              {newsType === '0' && <FormRadioGroup {...leaveWordProps} />}
              {/* 内容可见范围 */}
              <FormCheckbox {...visibleRangeProps} />
            </>
          )}
      </>
    );
  };

  chooseArticle = (index) => {
    const { dispatch, articleList, form } = this.props;
    dispatch({
      type: 'edit/saveState',
      payload: {
        currentIndex: index,
      },
    });
    form.setFieldsValue({ ...articleList[index] });
    if (this.newstype === '0') {
      this.setWweiEditorContent(articleList[index]?.content || '')
    }
    this.setState({
      checkedValue: [],
    });
  }

  articleOption = (type, index) => {
    const { articleList, dispatch, currentIndex } = this.props;
    const arr = JSON.parse(JSON.stringify(articleList))

    if (type === 'up') {
      arr.splice(index - 1, 0, (arr[index]))
      // 删除后一项
      arr.splice(index + 1, 1)
    }

    if (type === 'down') {
      arr.splice(index + 2, 0, (arr[index]))
      // 删除前一项
      arr.splice(index, 1)
    }

    if (type === 'delete') {
      arr.splice(index, 1);
    }

    dispatch({
      type: 'edit/saveState',
      payload: {
        articleList: arr,
        currentIndex: type === 'delete' ? 0 : currentIndex
      },
    });
  }

  renderList = (item, index) => {
    const { currentIndex, articleList } = this.props;
    const { fileList, title } = item;
    const { length } = articleList;
    return (
      <div
        className={`common-item ${index === 0 ? 'first-item' : ''} ${currentIndex === index ? 'activeBorder' : ''}`}>
        <div onClick={() => this.chooseArticle(index)}>
          {
            index === 0 ? (
              <>
                <div className="cover">
                  <img src={fileList[0]?.thumbUrl || defaultImageUrl} alt="" />
                  <>
                    <span className="mask" />
                    <span className="text">{title || '标题'}</span>
                  </>
                </div>
              </>
            ) : (
                <>
                  <div className="list-item-title">
                    <div>{title || '标题'}</div>
                    <img src={fileList[0]?.thumbUrl || defaultImageUrl} alt="" />
                  </div>
                </>
              )
          }
        </div>
        {
          currentIndex === index && articleList.length > 1 && (
            <div className="action">
              {
                index !== 0 && <img className="up-icon" src={upIcon} alt="" onClick={() => this.articleOption('up', index)} />
              }
              {
                index !== length - 1 && <img className="down-icon" src={downIcon} alt="" onClick={() => this.articleOption('down', index)} />
              }
              {
                articleList.length > 1 && (
                  <Popconfirm
                    placement="bottom"
                    title='是否确定删除此篇内容？'
                    onConfirm={() => {
                      this.articleOption('delete', index)
                    }}
                    okText="确定"
                    cancelText="取消"
                  >
                    <img className="delete-icon" src={deleteIcon} alt="" />
                  </Popconfirm>
                )
              }
            </div>
          )
        }
      </div>
    )
  };

  addArticle = () => {
    const { articleList, dispatch } = this.props;
    const arr = JSON.parse(JSON.stringify(articleList))
    const addData = {
      newstype: this.newstype,
      title: '',
      summary: '',
      url: '',
      coverPicFileId: '',
      content: '',
      fileId: '',
      labelList: [],
      status: '',
      statusDesc: '',
      channelId: undefined, // 栏目id
      fileList: [],
    }
    arr.push(addData)
    dispatch({
      type: 'edit/saveState',
      payload: {
        articleList: arr,
      },
    });
    this.chooseArticle(arr.length - 1)
  }

  moreArticle = () => {
    const { articleList } = this.props;
    return (
      <div className='information-wrap'>
        {
          !this.id && (
            <div className='more-content-wrap'>
              <div className={styles.leftRoot}>
                <section className="select-list">
                  <div className="list-wrap">
                    {
                      articleList.map((item, index) => {
                        return this.renderList(item, index)
                      })
                    }
                  </div>
                  {
                    articleList.length < 8 && (
                      <div className="list-wrap">
                        <div className='common-item add' onClick={this.addArticle}><Icon type="plus" /> {Number(this.newstype) === 0 ? '新建图文文章' : '新建外链文章'}  </div>
                      </div>
                    )
                  }
                </section>
              </div>
            </div>
          )
        }
        <div style={{ width: '100%' }}>
          {this.renderInformation()}
        </div>
      </div>
    )
  }

  render() {
    const { spinning, activeKey } = this.state;

    const { form, currentUser, formData, currentIndex, articleList } = this.props;
    const { getFieldsValue } = form;
    const { orgType } = currentUser || {};
    const { selectId } = formData;

    const { filesLength } = articleList[currentIndex] || {}

    return (
      <Container breStates={!0} version={2} defaultPadding footerParams={this.renderFooter()}>
        <div className={styles['microsite-edit-spin']}>
          <Spin spinning={spinning}>
            <div className={styles.root}>
              <FormCreate customerFormItemLayout={customerFormItemLayout}>
                {Number(getAppCode()) === 1 ? (
                  <Tabs defaultActiveKey="1" activeKey={activeKey} onChange={this.changeTab}>
                    <TabPane forceRender tab={this.renderTabTitle(activeKey, '信息填写', '1')} key="1">
                      {this.moreArticle()}
                    </TabPane>
                    <TabPane forceRender tab={this.renderTabTitle(activeKey, '对象选择', '2')} key="2">
                      {this.renderSelectUser()}
                    </TabPane>
                    <TabPane forceRender tab={this.renderTabTitle(activeKey, '发送属性', '3')} key="3">
                      {this.renderAttribute()}
                    </TabPane>
                  </Tabs>
                ) : (
                    // eslint-disable-next-line react/jsx-indent
                    <Tabs defaultActiveKey="1" activeKey={activeKey} onChange={this.changeTab}>
                      <TabPane forceRender tab={this.renderTabTitle(activeKey, '信息填写', '1')} key="1">
                        {/* {this.renderInformation()} */}
                        {this.moreArticle()}
                      </TabPane>
                      <TabPane forceRender tab={this.renderTabTitle(activeKey, '发送属性', '2')} key="2">
                        {this.renderAttribute()}
                      </TabPane>
                    </Tabs>
                  )}
              </FormCreate>
              <PublishModal
                values={getFieldsValue()}
                selectId={selectId}
                filesLength={filesLength}
                handleOk={this.saveArticle}
                orgType={orgType}
              />
            </div>
          </Spin>
        </div>
      </Container>
    );
  }
}

export default Edit;
